export enum RecurringExpenseFrequency {
  Monthly = 0,
  Quarterly = 1,
  Annually = 2,
  BiWeekly = 3,
  TwiceMonthly = 4,
  Weekly = 5,
}
